import { type Components, type Theme } from "@mui/material/styles";

export const cssBaseline: Components<Theme>["MuiCssBaseline"] = {
  styleOverrides: {
    "@keyframes pulse": {
      "0%, 100%": { opacity: 1, transform: "scale(1)" },
      "50%": { opacity: 0.5, transform: "scale(1.4)" },
    },
  },
};
